import React, { useState } from 'react';
import { getUILoc, getCardName, groupCards } from '../../../utils/cardUtils.js';
import { CardIllustration } from '../../Card.js';
import CardDetail from '../../CardDetail.js';

const SharpenEvent = ({ activeRun, cardDefs, executeSharpenRemove, goToNextNodeSelection }) => {
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [eventResultMessage, setEventResultMessage] = useState(null);
  const [inspectCard, setInspectCard] = useState(null);

  const remaining = activeRun.eventState.remaining || 0;
  const removedCount = activeRun.eventState.removedCount || 0;

  const handleRemove = () => {
    const cardName = getCardName(selectedCardId);
    const res = executeSharpenRemove(selectedCardId);
    if (res.success) {
      setSelectedCardId(null);
      if (removedCount + 1 === 5) {
        if (activeRun.matchedCount >= 5) {
          setEventResultMessage(getUILoc('YONOTSUNE.EVENTS.SHARPEN.RESULT_BONUS').replaceAll('{card}', cardName).replaceAll('{count}', 5).replaceAll('{bonus}', 7));
        } else {
          setEventResultMessage(getUILoc('YONOTSUNE.EVENTS.SHARPEN.RESULT_BONUS').replaceAll('{card}', cardName).replaceAll('{count}', 5).replaceAll('{bonus}', 3));
        }
      } else {
        setEventResultMessage(getUILoc('YONOTSUNE.EVENTS.SHARPEN.RESULT').replace('{card}', cardName));
      }
    } else {
      alert(res.reason);
    }
  };

  // デッキの集計
  const groupedDeck = groupCards(activeRun.playerDeck);

  return (
    <div className="event-resolver sharpen-event">
      <h2>{getUILoc('YONOTSUNE.EVENTS.SHARPEN.NAME')}</h2>
      <p className="resolver-intro" dangerouslySetInnerHTML={{ __html: getUILoc('YONOTSUNE.EVENTS.SHARPEN.INTRO', { count: remaining }) }} />

      {eventResultMessage && <div className="event-result-banner">{eventResultMessage}</div>}

      <div className="sharpen-box">
        <div className="card-selector-area">
          <h3>{getUILoc('LABELS.CURRENT_DECK')}:</h3>
          <div className="modal-scroll-area" style={{ marginTop: '10px' }}>
            <div className="presented-grid">
              {groupedDeck.map((item, index) => {
                const isActive = selectedCardId === item.id;
                return (
                  <div 
                    key={index} 
                    className={`pile-card-group clickable ${isActive ? 'active' : ''}`}
                    onClick={() => setSelectedCardId(item.id)}
                    style={{ border: isActive ? '2px solid #f44336' : '1px solid rgba(255,255,255,0.1)', background: isActive ? 'rgba(244, 67, 54, 0.1)' : 'transparent', padding: '5px' }}
                  >
                    <div className="pile-card-illustration-wrapper">
                      <CardIllustration cardId={item.id} isMini={true} />
                      <div className="pile-card-count-badge">×{item.count}</div>
                      <button className="inspect-btn-mini" style={{ position: 'absolute', bottom: '2px', right: '2px', zIndex: 5 }} onClick={(e) => { e.stopPropagation(); setInspectCard(cardDefs[item.id]); }}>🔍</button>
                    </div>
                    <div className="pile-card-name" style={{ fontSize: '0.7rem' }}>{getCardName(item.id)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="action-row" style={{ marginTop: '20px' }}>
          <button 
            className="yonotsune-btn danger-btn" 
            disabled={!selectedCardId || remaining <= 0}
            onClick={handleRemove}
            style={{ flex: 1 }}
          >
            {getUILoc('YONOTSUNE.EVENTS.SHARPEN.EXECUTE')}
          </button>
          <button className="yonotsune-btn" onClick={() => { goToNextNodeSelection(); setEventResultMessage(null); }} style={{ flex: 1 }}>
            {getUILoc('YONOTSUNE.EVENTS.NEXT_NODE')}
          </button>
        </div>
      </div>

      {inspectCard && (
        <CardDetail 
          card={inspectCard} 
          cardDefs={cardDefs} 
          onClose={() => setInspectCard(null)} 
        />
      )}
    </div>
  );
};

export default SharpenEvent;
